<template>
  <MapPin
    :google="google"
    :map="map"
    :mapState="mapState"
    :hasIcon="true"
    :hasLabel="true"
    :position="position"
    @click="$emit('click', $event)">
    <template v-slot:icon>
      <div :class="`marker-routeevent-icon`">
        <i :class="['fas', routeEventIcon]" />
      </div>      
    </template>
    <template v-slot:label v-if="routeEvent">
      {{formatLookupName(routeEvent.type, TaskUserRouteEventTypeLookup)}}
    </template>
  </MapPin>
</template>

<style scoped lang="scss">
.marker-routeevent-icon {
  padding: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  line-height: 21px;
  vertical-align: middle;
  background-color: $status-danger;
  text-align: center;
  font-size: 11px;
  color: #ffffff;
}
</style>

<script>
import MapPin from '@/components/maps/mapPin'

import { TaskUserRouteEventTypes, TaskUserRouteEventTypeLookup } from '@/store/types'

export default {
  name: 'MapTaskRouteEventMarker',
  components: {
    MapPin
  },
  props: {
    google: {
      type: Object,
      required: true
    },
    map: {
      type: Object,
      required: true
    },
    position: {
      type: Object,
      required: true
    },
    routeEvent: Object,
    mapState: Object,
    task: Object
  },
  data() {
    return {
    }
  },
  computed: {
    routeEventIcon() {
      if(!this.routeEvent.type)
        return ''

      switch(this.routeEvent.type) {
        case TaskUserRouteEventTypes.signalLoss:
          return 'fa-wifi'
        case TaskUserRouteEventTypes.stoppage:
          return 'fa-exclamation'
      }
      return ''
    }
  },
  watch: {
  },
  created() {
    this.TaskUserRouteEventTypeLookup = TaskUserRouteEventTypeLookup
  },
  mounted() {

  },
}
</script>